export const entityFilingDecisionsSelector = ({ filingDecisionsV2 }) =>
  filingDecisionsV2.entityFilingDecisions;
export const isFetchingEntityFilingDecisionsSelector = ({ filingDecisionsV2 }) =>
  filingDecisionsV2.isFetchingEntityFilingDecisions;

export const isFetchingAmountDetailsSelector = ({ filingDecisionsV2 }) =>
  filingDecisionsV2.isFetchingAmountDetails;
export const amountDetailsSelector = ({ filingDecisionsV2 }) => filingDecisionsV2.amountDetails;
